import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/expand/page.tsx");
